import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import ScoringMatrix from './componentMatriz/scoringMatrix';

function ModalMatriz(props) {
    const [contractsSelected, setContractsSelected] = useState(
        props.contractsSelected
    );
    const [contractColors, setContractColors] = useState(
        setContractColorsInitial
    );
    useEffect(() => {
        var colors = props.matrixContractsColor.split(',');
        colors.forEach(element => {
            document
                .querySelectorAll('.color-' + element)
                .forEach(function (bubble) {
                    if (bubble.classList[0] === 'scoringBubble')
                        bubble.classList.add('selected');
                });
        });
    }, []);

    useEffect(() => {
        setContractsSelected(props.contractsSelected);
    }, [props.contractsSelected]);

    useEffect(() => {
        setContractColors(setContractColorsInitial());
    }, [props.matrixContractsColor]);

    function setContractColorsInitial() {
        var colors = props.matrixContractsColor.split(',');
        var _colorContracts = [];
        colors.forEach(element => {
            if (element !== '') _colorContracts.push('color-' + element);
        });
        if (JSON.stringify(_colorContracts) !== contractColors)
            return _colorContracts;
    }
    const renderContractIcons = () => {
        let icons = [];

        for (let i = 0; i < contractColors.length; i++)
            icons.push(<span key={i} className={contractColors[i]}></span>);

        return <div className="contract-circle-div">{icons}</div>;
    };

    const setTablematrixContracts = () => {
        if (contractColors.length > 0) {
            let matrixContracts = '';
            matrixContracts = contractColors.join(',');
            matrixContracts = matrixContracts.replaceAll('color-', '');
            props.setMatrixContracts(matrixContracts);
        } else props.setMatrixContracts('');
        props.setContractsSelected(contractsSelected);
        props.setModalMatriz(false);
    };

    return (
        <div className="c-modal">
            <div
                className="c-modal__overlay js-modal-close"
                onClick={() => props.setModalMatriz(false)}
            ></div>
            <div
                className="c-modal__wrapper modalPosition_FilterMatriz"
                role="dialog"
                aria-labelledby="foo-bar-baz"
            >
                <header
                    className="c-modal__header"
                    style={{
                        padding: '0px',
                        paddingTop: '10px',
                    }}
                >
                    <div className="o-layout__item u-10/12 ">
                        <label className=" c-modal__title">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                            >
                                <g
                                    id="Grupo_68433"
                                    data-name="Grupo 68433"
                                    transform="translate(-26.5 -14.5)"
                                >
                                    <circle
                                        id="Oval-Copy-18"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(26.5 14.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-21"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(26.5 20.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-24"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(26.5 26.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-19"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(32.5 14.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-22"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(32.5 20.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-25"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(32.5 26.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-20"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(38.5 14.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-23"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(38.5 20.5)"
                                        fill="#004666"
                                    />
                                    <circle
                                        id="Oval-Copy-26"
                                        cx="2"
                                        cy="2"
                                        r="2"
                                        transform="translate(38.5 26.5)"
                                        fill="#004666"
                                    />
                                </g>
                            </svg>
                            <span className="mideltextfilter u-text-brand">
                                Matriz
                            </span>
                        </label>
                    </div>

                    <div className="o-layout__item u-2/12">
                        <button
                            onClick={() => props.setModalMatriz(false)}
                            className="c-modal__close-btn  js-modal-close"
                            type="button"
                            aria-label="Cerrar modal."
                        />
                    </div>
                </header>
                <div
                    className="c-modal__content"
                    role="document"
                    style={{ marginTop: '6px', paddingBottom: '10px' }}
                >
                    <div className="u-text-left maginBoton">
                        <p>Te ayudamos a decidir qué clientes impactar.</p>
                        <p>
                            Selecciona los grupos de vencimientos que quieres
                            ver.
                        </p>
                    </div>
                    <div className="u-text-left">
                        <p>
                            Selecciona por probabilidad de renovación.
                            <button
                                style={{ marginLeft: '10px' }}
                                className={
                                    'js-tooltip c-icon c-info-icon c-icon--[semantic-info]'
                                }
                                data-tippy-content={
                                    'Verde significa más propenso a renovación ya sea por la situación del vehículo o por la fidelidad del cliente. Rojo significa menos propenso a renovación.'
                                }
                                data-tippy-placement={''}
                            ></button>
                        </p>
                    </div>
                    <ScoringMatrix
                        cookies={props.cookies}
                        contractsSelected={contractsSelected}
                        setContractsSelected={setContractsSelected}
                        contractColors={contractColors}
                        setContractColors={setContractColors}
                        dealerCodeVWF={props.dealerCodeVWF}
                        matrixData={props.matrixData}
                    />

                    <div className="o-layout vehicles-selected-div">
                        <div className="o-layout__item u-1/1">
                            <span className="num-contracts">
                                {contractsSelected}
                            </span>
                            {renderContractIcons()}
                            <span className="vehicles-selected">
                                Vencimientos seleccionados
                            </span>
                            <div className="u-1/1">
                                <button
                                    className="c-btn c-btn--secondary"
                                    style={{ width: '45%' }}
                                    onClick={() => setTablematrixContracts()}
                                >
                                    Ver vencimientos
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default withRouter(ModalMatriz);
